import React from "react";

const Copyright = ({ copyright, config }) => (
  <div className="pull-lg-right copyright-container stay_connected">
    <span>
      &copy; {copyright} {config.footerCopyright.text(config)}
    </span>
    <span className="hidden-lg-up">&copy; {copyright} CardCash</span>
  </div>
);

export default Copyright;
